/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".avatar-container[_ngcontent-%COMP%]{text-align:center;margin:10px 0}.avatar-container[_ngcontent-%COMP%]   .avatar[_ngcontent-%COMP%]{border-radius:35px 35px 10px 10px;box-shadow:0 5px 5px #888;margin-bottom:10px}.guess-container[_ngcontent-%COMP%]{margin-top:10px}.guess-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:auto;max-height:100%;width:auto;max-width:100%;margin:0 auto;text-align:center;display:block}.guess-container[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{margin:5px auto;width:100%}"];
export { styles as styles };
